import { render, staticRenderFns } from "./DocumentSidebar.vue?vue&type=template&id=0b4e5b5d&scoped=true"
import script from "./DocumentSidebar.vue?vue&type=script&lang=js"
export * from "./DocumentSidebar.vue?vue&type=script&lang=js"
import style0 from "./DocumentSidebar.vue?vue&type=style&index=0&id=0b4e5b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e5b5d",
  null
  
)

export default component.exports